export default "__VITE_ASSET__DQHmRMUt__"